/**
 * Dulora geo offer — swaps the regional minimum-spend amount into the
 * Shopify Forms first-order pop-up. The copy is authored once in the Forms
 * app with any amount after "over" (e.g. "Valid on orders over $149"); the
 * region and amount come from snippets/dulora-geo-offer.liquid via
 * window.theme.geoOffer. Only text inside <shopify-forms-embed> is touched.
 */
(() => {
  const offer = window.theme && window.theme.geoOffer;
  if (!offer || !offer.threshold || window.duloraGeoOfferInit) return;
  window.duloraGeoOfferInit = true;

  // "over $149", "over NZ$179", "over S$179", "over AED 499", "over ₹7,999", "over $99 USD".
  // A currency marker is required so phrases like "over 18" are left alone.
  const AMOUNT_RE = /(\b[Oo]ver\s+)(?:[A-Z]{1,3}\s?[$£€₹]?|[$£€₹])\s?\d(?:[\d,.]*\d)?(?:\s[A-Z]{3}\b)?/g;

  const observed = new WeakSet();

  const patch = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.nodeValue;
      const next = text.replace(AMOUNT_RE, (match, lead) => lead + offer.threshold);
      if (next !== text) node.nodeValue = next;
    }

    // The Forms app nests components with their own shadow roots.
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) watch(el.shadowRoot);
    });
  };

  function watch(root) {
    if (observed.has(root)) return;
    observed.add(root);

    // The form renders async and re-renders between steps, so keep patching.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        patch(root);
      });
    }).observe(root, { childList: true, subtree: true, characterData: true });

    patch(root);
  }

  const scan = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      if (embed.shadowRoot) watch(embed.shadowRoot);
    });
  };

  let scanQueued = false;
  new MutationObserver(() => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });

  customElements.whenDefined('shopify-forms-embed').then(scan);
  scan();
})();
